//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { WebsiteCustomFieldDisplayItem } from './WebsiteCustomFieldDisplayItem';
import { FormAffinity, WebsiteBlockType } from './Enums';

export class WebsiteCustomFieldSignupFormDisplayItem extends WebsiteCustomFieldDisplayItem {
    Affinity: FormAffinity = FormAffinity.Form;
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.SignupForm;

    constructor(initializer?: Partial<Omit<WebsiteCustomFieldSignupFormDisplayItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteCustomFieldSignupFormDisplayItem";
}
